import client from './client';
import type { SafeUser, Company } from '../types/auth';

interface LoginResponse {
  token: string;
  user: SafeUser;
  company: Company | null;
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  const { data } = await client.post<LoginResponse>('/api/auth/login', { username, password });
  return data;
}

export async function fetchMe(): Promise<{ user: SafeUser; company: Company | null }> {
  const { data } = await client.get<{ user: SafeUser; company: Company | null }>('/api/auth/me');
  return data;
}

export async function logoutApi(): Promise<void> {
  await client.post('/api/auth/logout');
}

export async function refreshToken(): Promise<{ token: string; user: SafeUser; company: Company | null }> {
  const { data } = await client.post<{ token: string; user: SafeUser; company: Company | null }>('/api/auth/refresh');
  return data;
}

export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  await client.put('/api/auth/password', { oldPassword, newPassword });
}
